module.exports = __webpack_public_path__ + "components/Map/graphics/ecommerce-cluster-pin.c52de1f3f6ec211b0a75782b727e00a6.png";